import {FC, SVGProps} from 'react';

/** Документ со сгибом угла — иконка «По номеру счёта». */
export const AccountPaymentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19.332 2V8.99902H25.9987L19.332 2Z" fill="black" />
		<path
			d="M17.1111 11.3359V2.00391H6V30H26V11.3359H17.1111ZM22.6667 22.988H9.33333V20.655H22.6667V22.988ZM22.6667 18.322H9.33333V15.989H22.6667V18.322Z"
			fill="black"
		/>
	</svg>
);
